module.exports = __webpack_public_path__ + "static/img/13.117d45c2.jpeg";